import React from 'react';
import { SvgIcon } from '@mui/material';

const LeftArrowIcon = ({ ...props }) => (
    <SvgIcon
        {...props}
        width="22px"
        height="36px"
        viewBox="0 0 22 36"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="🎨-Style-Guide" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g
                id="Pegasus-Mobile-App-Style-Guide"
                transform="translate(-331.000000, -2703.000000)"
                fill="#111111"
                fillRule="nonzero"
            >
                <g id="1.-Icon/Arrow/Left/Large" transform="translate(321.000000, 2697.000000)">
                    <path
                        d="M29.0506612,42.0003923 C28.4773285,42.0003923 27.9025067,41.7798923 27.4691566,41.3358923 L10.5,24.1113923 L27.6865763,6.66339231 C28.5532765,5.78439231 29.965015,5.77689231 30.8406503,6.65289231 C31.7147964,7.52589231 31.7207531,8.94939231 30.8525637,9.83139231 L16.7872996,24.1113923 L30.6336549,38.1693923 C31.5018443,39.0498923 31.4973768,40.4733923 30.6232306,41.3463923 C30.1883914,41.7828923 29.6195263,42.0003923 29.0506612,42.0003923"
                        id="↳Select-Color"
                    />
                </g>
            </g>
        </g>
    </SvgIcon>
);

export default LeftArrowIcon;
